import { Dayjs } from 'dayjs';
import { dayjs, ET } from './shared/date';
import { TokenTimeframe, ALPHA_TOKEN_OVERRIDES } from '../config/user';
import {
  AFFILIATE_PRODUCTS,
  BETA_ONLY_PRODUCTS,
  INTERNAL_ONLY_PRODUCTS,
  DEV_ONLY_PRODUCTS,
  BLOOMBERG_EXCLUDE_PRODUCTS,
} from '../config/shared';
import { ProductType } from 'types/shared';
import { getEnv, isBloomberg } from '../util';
import { hasDashAccess, DashAccess } from 'types/user';

// find the first matching valid override, or undefined if no matches
export const getTokenOverrideTimeframe = (time: Dayjs) =>
  ALPHA_TOKEN_OVERRIDES.find((tf) => isInOverrideTimeframe(time, tf));

export const isInOverrideTimeframe = (
  time: Dayjs,
  tokenTimeframe: TokenTimeframe,
) => {
  return time.isBetween(tokenTimeframe.minDate, tokenTimeframe.maxDate);
};

export const isValidTokenOverrideTimeframe = () => {
  const nowET = dayjs().tz(ET);

  return ALPHA_TOKEN_OVERRIDES.some((tokenTimeframe) =>
    isInOverrideTimeframe(nowET, tokenTimeframe),
  );
};

export const getOpenHouseToken = () => {
  const nowET = dayjs().tz(ET);

  const validOverride = ALPHA_TOKEN_OVERRIDES.find((tokenTimeframe) =>
    isInOverrideTimeframe(nowET, tokenTimeframe),
  );

  if (validOverride != null) {
    return validOverride.token;
  }

  return null;
};

export const hasDashAccessToProduct = (
  userDashAccess: DashAccess,
  product: ProductType,
) => {
  if (BLOOMBERG_EXCLUDE_PRODUCTS.includes(product) && isBloomberg()) {
    return false;
  }

  // Treat AFFILIATE access separate from the below logic as products
  // launched to affiliates can overlap with those shipped to BETA
  if (
    userDashAccess === DashAccess.AFFILIATE &&
    AFFILIATE_PRODUCTS.includes(product)
  ) {
    return true;
  }

  if (BETA_ONLY_PRODUCTS.includes(product)) {
    return hasDashAccess(userDashAccess, DashAccess.BETA);
  } else if (INTERNAL_ONLY_PRODUCTS.includes(product)) {
    return hasDashAccess(userDashAccess, DashAccess.INTERNAL);
  } else if (DEV_ONLY_PRODUCTS.includes(product)) {
    return getEnv() === 'development';
  }
  return true;
};
